import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Stack } from 'react-bootstrap';
import { Loading } from '../../../../components/loading/Loading';
import { OrganizationContext } from '../../../../context/organization_context/OrganizationContext';
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react';
import { fetchTimesheetsForReview } from '../../../../repository/TimeSheetDAO';
import AppSidebar from '../../../../components/navbar/DesktopAppSidebar';
import { TableBody, TableCell, TableContainer, TableHead, TableRow, Table } from '@mui/material';
import moment from 'moment';
import { useLoadingContext } from '../../../../context/loading/LoadingContext';
import ApproveModal from './modals/ApprovalModal';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../../resources/strings/StringKeys';

function Approvals() {
    const { organization } = useContext(OrganizationContext);
    const [currentDate, setCurrentDate] = useState(moment());
    const { setLoadingData } = useLoadingContext()
    const [timeSheets, setTimeSheets] = useState();
    const [timesheetForApproval, setTimesheetForApproval] = useState()
    const [showApproveModal, setShowApproveModal] = useState(false)
    const { t } = useTranslation();
    
    const previousWeek = () => {
        setCurrentDate(prevDate => prevDate.clone().subtract(1, 'week'));
    };

    const nextWeek = () => {
        setCurrentDate(prevDate => prevDate.clone().add(1, 'week'));
    };

    useEffect(() => {
        if (organization && currentDate) {
            const weekStart = currentDate.clone().startOf('week').format('YYYY-MM-DD');
            fetchTimesheetsForReview(organization.id, weekStart)
                .then(fetchedTimeSheets => {
                    setTimeSheets(fetchedTimeSheets); 
                })
                .catch(error => {
                    console.error("Error fetching time sheets:", error);
                });
        }
    }, [organization, currentDate, setLoadingData]);

    return (
        <>
            {organization && currentDate && timeSheets ? (
                <>
                <AppSidebar
                    content={
                    <Stack gap={3}>
                        <div></div>
                        <Row className="align-items-center">
                            <Col sm><h2>{t(StringKeys.APPROVALS)}</h2></Col>
                            <Col sm>{t(StringKeys.WEEK_OF)}: {currentDate.clone().startOf('week').format('MM-DD-YYYY')}</Col>
                            <Col sm style={{textAlign:"end"}}>
                                <Button style={{marginRight:"10px"}} onClick={previousWeek}><IconArrowLeft/> {t(StringKeys.PREVIOUS)}</Button>
                                <Button onClick={nextWeek}>{t(StringKeys.NEXT)} <IconArrowRight/></Button>
                            </Col>
                        </Row>
                        <TableContainer>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ fontWeight: 'bold' }}>{t(StringKeys.EMPLOYEE_ID)}</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }}>{t(StringKeys.TOTAL_HOURS)}</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }}>{t(StringKeys.STATUS)}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {timeSheets.map((timeSheet) => (
                                    <TableRow 
                                    onClick={() => {
                                        setTimesheetForApproval(timeSheet)
                                        setShowApproveModal(true)
                                        
                                    }} 
                                    key={timeSheet.id} style={{ cursor: 'pointer' }}>
                                        <TableCell>{timeSheet.employee_id}</TableCell>
                                        <TableCell>{timeSheet.total_hours}</TableCell>
                                        <TableCell>{timeSheet.status}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <TableBody>

                            </TableBody>
                        </Table>
                        </TableContainer>
                        <ApproveModal
                            show={showApproveModal}
                            onHide={() => setShowApproveModal(false)}
                            timesheet={timesheetForApproval}
                        />
                    </Stack>
                } 
                />
                </>
            ) : <AppSidebar content={<Loading />} />}
        </>
    );
}

export default Approvals
